export default [
  {
    path: '/classcard/mamage',
    name: 'PageClasscard',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscard'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '智慧班牌',
      info: '班牌——班牌管理'
    }
  },
  {
    path: '/classcard/config',
    name: 'PageClasscardConfig',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardConfig'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '配置',
      info: '班牌——配置'
    }
  },
  {
    path: '/classcard/qingtian/config',
    name: 'QingTianConfig',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/QingTianConfig'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '班牌开门权限',
      info: '班牌——青田配置'
    }
  },
  {
    path: '/classcard/qingtian/config/edit',
    name: 'QingTianConfigEdit',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/QingTianConfigEdit'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '编辑权限组',
      info: '班牌——编辑权限组'
    }
  },
  {
    path: '/classcard/qingtian/config/range',
    name: 'QingTianConfigRange',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/QingTianConfigRange'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '指定范围',
      info: '班牌——指定范围'
    }
  },
  {
    path: '/classcard/config/name',
    name: 'PageClasscardConfigName',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardConfigName'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '配置',
      info: '班牌——配置'
    }
  },
  {
    path: '/classcard/config/wallpaper',
    name: 'PageClasscardConfigWallpaper',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardConfigWallpaper'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '配置',
      info: '班牌——配置'
    }
  },
  {
    path: '/classcard/time/light',
    name: 'PageClasscardLightTime',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardLightTime'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '常亮时间',
      info: '班牌——常亮时间'
    }
  },
  {
    path: '/classcard/edit',
    name: 'PageClasscardEdit',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardEdit'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '配置',
      info: '班牌——配置'
    }
  },
  {
    path: '/classcard/time',
    name: 'PageClasscardTime',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardTime'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '定期开关机',
      info: '班牌——班牌定期开关机'
    }
  },
  {
    path: '/classcard/device',
    name: 'PageDevice',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDevice'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '设备管理',
      info: '设备管理——首页'
    }
  },
  {
    path: '/classcard/device/detail',
    name: 'PageDeviceDetail',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDeviceDetail'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '设备详情',
      info: '设备——设备详情'
    }
  },
  {
    path: '/classcard/device/detailname',
    name: 'PageDeviceDetailName',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDeviceDetailName'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '绑定班级',
      info: '设备——绑定班级'
    }
  },
  {
    path: '/classcard/device/version',
    name: 'PageDeviceVersion',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDeviceVersion'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      info: '版本信息',
      title: '设备——版本信息'
    }
  },
  {
    path: '/classcard/device/network',
    name: 'PageDeviceNetwork',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDeviceNetwork'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '网络状态',
      info: '设备——网络状态'
    }
  },
  {
    path: '/classcard/device/update',
    name: 'PageDeviceUpdate',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDeviceUpdate'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '批量升级',
      info: '设备——批量升级'
    }
  },

  {
    path: '/classcard/mode',
    pathType: 'full',
    name: 'PageClasscardMode',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardMode'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '设备模式',
      info: '设备——设备模式'
    }
  },
  {
    path: '/chooseCampus',
    name: 'PageChooseCampus',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageChooseCampus'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '选择校区',
      info: '自定义模式——选择校区'
    }
  },
  {
    path: '/classcard/mode',
    pathType: 'gray',
    name: 'GrayPageClasscardMode',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/gray/PageClasscardMode'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '设备模式',
      info: '设备——设备模式'
    }
  },
  {
    path: '/classcard/template',
    name: 'PageClasscardTemplate',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardTemplate'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '班牌模式',
      info: '设备——班牌模式'
    }
  },
  {
    path: '/classcard/device/list',
    name: 'PageDeviceList',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageDeviceList'
      ),
    meta: { modular: 27, aliaModular: 32, title: '设备列表', info: '设备列表' }
  },
  {
    path: '/classcard/password',
    name: 'PageClasscardPwd',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardPwd'
      ),
    meta: {
      modular: 27,
      aliaModular: 32,
      title: '后台密码',
      info: '设备——后台密码'
    }
  },

  {
    path: '/classcard/examMode',
    name: 'PageClasscardExamMode',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classcard/PageClasscardExamMode'
      ),
    meta: {
      keepAlive: true,
      modular: 27,
      aliaModular: 32,
      title: '考场模式',
      info: '设备——考场模式'
    }
  }
]
